<template>
  <div :id="pick.id">
    <div class="tags is-right">
      <span class="tag is-medium is-primary is-light">{{type}}</span>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Away/Home" grouped expanded>
          <b-input expanded placeholder="Away" v-model="awayTeam" />
          <b-input expanded placeholder="Home" v-model="homeTeam" />
        </b-field>

        <b-field label="Body" message="Ex: Broncos -7">
          <b-input v-model="body" />
        </b-field>

        <b-field label="Instructions">
          <b-input type="textarea" v-model="instructions" />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Date/Time">
          <b-datetimepicker v-model="dateTime" />
        </b-field>

        <b-field grouped label="To Win/Risk">
          <b-input expanded placeholder="To Win" type="number" step=".01" v-model.number="gain" @input="setDefaultRisk" />
          <b-input expanded placeholder="Risk" type="number" step=".01" v-model.number="risk" />
        </b-field>

        <b-field label="Type">
          <b-input v-model="type" />
        </b-field>

      </div>
    </div>

    <div class="buttons is-right">
      <button @click.prevent="update"
              :disabled="!isDirty || loading"
              :class="`button is-success ${loading ? 'is-loading' : ''}`">
        Save
      </button>
      <button @click.prevent="reset" :disabled="!isDirty || loading" class="button is-warning is-outlined">Cancel</button>
      <button @click.prevent="remove" :disabled="loading" :class="`button is-danger is-outlined ${loading ? 'is-loading' : ''}`">Delete</button>
    </div>
  </div>
</template>

<script>
import { updateAdminPick, removeManualPick } from '@/utils/api';
import {BDatetimepicker} from 'buefy/dist/esm/datetimepicker';

export default {
  components: {
    BDatetimepicker
  },
  props: {
    pick: Object
  },
  data() {
    return {
      title: '',
      awayTeam: '',
      homeTeam: '',
      dateTime: new Date(),
      type: 'Spread',
      body: '',
      risk: 0,
      gain: 0,
      instructions: '',
      service: '',
      loading: false,
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    setDefaultRisk: function () {
      let {gain} = this;
      let standardOdds = 110/100;
      let standardRisk = gain*standardOdds;

      this.risk = parseFloat(standardRisk.toFixed(2));
    },
    reset: function () {
      // Strings
      ['title', 'awayTeam', 'homeTeam', 'type', 'body', 'instructions', 'service',]
      .forEach(fillableDatum => {
        this[fillableDatum] = this.pick[fillableDatum] || '';
      });

      // Numbers
      ['risk', 'gain']
      .forEach(fillableDatum => {
        this[fillableDatum] = this.pick[fillableDatum] || 0;
      });

      // Dates
      ['dateTime']
      .forEach(fillableDatum => {
        let datum = this.pick[fillableDatum];

        this[fillableDatum] = datum ? new Date(datum) : new Date();
      })
    },
    update: async function () {
      let {id} = this.pick;
      let {title, awayTeam, homeTeam, dateTime, type, body, risk, gain, instructions, service} = this;
      let date = dateTime.toLocaleDateString();
      let time = dateTime.toLocaleTimeString();
      let payload = {
        id,
        service,
        edits: {
          title,
          awayTeam,
          homeTeam,
          dateTime: dateTime.getTime(),
          date,
          time,
          type,
          body,
          risk,
          gain,
          instructions,
          service
        }
      };

      this.loading = true;
      let res = await updateAdminPick(payload);
      this.loading = false;

      if (!res.ok) {
        this.$buefy.toast.open('Pick Not Updated');
      }

      let resBody = await res.json();
      console.log({resBody});
      this.$buefy.toast.open({
        message: 'Pick Updated',
        type: 'is-success'
      });

      this.$emit('pickUpdated', {...this.pick, ...this.$data});

    },
    remove: async function() {
      this.loading = true;
      let res = await removeManualPick({id: this.pick.id, service: this.pick.service});
      this.loading = false;

      if (res.ok) {
        this.$buefy.toast.open('Pick Removed');
        this.$emit('pickRemoved', JSON.parse(JSON.stringify(this.pick)))
        console.log(await res.json());
      }
    }
  },
  computed: {
    isDirty: function () {
      return [
            'title',
            'awayTeam',
            'homeTeam',
            'type',
            'body',
            'instructions',
            'service',
            'risk',
            'gain'
          ].some(field => this[field] !== this.pick[field])

          ||

          ['dateTime']
            .some(field => {
              if (field instanceof Date) {
                return this[field].getTime() !== this.pick[field].getTime();
              }

              return new Date(this[field]).getTime() !== new Date(this.pick[field]).getTime();
            });
    }
  }
}
</script>

<style lang="scss">
//@import "~buefy/src/scss/utils/all";
@import "~buefy/src/scss/utils/functions";
@import "~buefy/src/scss/utils/variables";
@import "~buefy/src/scss/components/pagination";
@import "~buefy/src/scss/components/timepicker";
@import "~buefy/src/scss/components/datepicker";
</style>